import React from "react";
import { Card, Button } from "react-bootstrap";

const Manage = () => {
  const cards = [
    { id: 1, name: "Card 1", balance: 20 },
    { id: 2, name: "Card 2", balance: 10 },
    { id: 3, name: "Card 3", balance: 5 },
  ];

  const handlePurchase = (cardId) => {
    // Handle purchase logic
    console.log(`Purchased card ${cardId}`);
  };

  const handleGift = (cardId) => {
    // Handle gift logic
    console.log(`Gifted card ${cardId}`);
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-6 col-lg-3">
          <Card>
            <Card.Body>
              <Card.Title>Card 1</Card.Title>
              <Card.Text>Balance: $20</Card.Text>
              <Button onClick={() => handlePurchase(1)}>Recharge</Button>
            </Card.Body>
          </Card>
        </div>
        <div className="col-sm-6 col-lg-3">
          <Card>
            <Card.Body>
              <Card.Title>Card 2</Card.Title>
              <Card.Text>Balance: $10</Card.Text>
              <Button onClick={() => handlePurchase(2)}>Recharge</Button>
            </Card.Body>
          </Card>
        </div>
        <div className="col-sm-6 col-lg-3">
          <Card>
            <Card.Body>
              <Card.Title>Card 3</Card.Title>
              <Card.Text>Balance: $5</Card.Text>
              <Button onClick={() => handlePurchase(3)}>Recharge</Button>
            </Card.Body>
          </Card>
        </div>
        <div className="col-sm-6 col-lg-3">
          <Card>
            <Card.Body>
              <Card.Title>Gift a Card</Card.Title>
              <Card.Text>Send a card to someone special</Card.Text>
              <Button onClick={() => handleGift()}>Gift Now</Button>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Manage;
